import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardHeader from "components/Card/CardHeader";
import Card from "components/Card/Card";
import CardIcon from "components/Card/CardIcon";
import { Check, MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel
} from "@material-ui/core";
import Datetime from "react-datetime";
import { tripDateFormat } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function ViewAgentBookingPromoCodes(props) {
  const [body, setBody] = useState({
    agentID: null,
    promoCode: null,
    effectiveFrom: null,
    effectiveUntil: null,
    discountAmount: null,
    minimumPax: null,
    maximumPax: null,
    onlyForRoundTrip: false,
    hasSectorRestriction: false,
    limit: 0,
    allowedSectorID: [],
    agent: null
  });

  const { id } = useParams();

  const viewAgentBookingPromoCodesSignal = React.useRef(new AbortController());

  const getData = () => {
    bookingApi
      .get("AgentBookingPromoCodes/" + id, {
        signal: viewAgentBookingPromoCodesSignal.current.signal,
        params: {
          ID: id
        }
      })
      .then(data => {
        setBody(data);
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    getData();

    return () => viewAgentBookingPromoCodesSignal.current.abort();
  }, []);

  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              VIEW AGENT BOOKING PROMO CODES
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Promo Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.promoCode ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Agent Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.agent ? body.agent.code : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Agent Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.agent ? body.agent.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Currency"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value:
                      body.agent && body.agent.billingCurrency
                        ? body.agent.billingCurrency.code
                        : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Discount Amount"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    type: "number",
                    value: body.discountAmount ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Minimum Pax"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.minimumPax ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Maximum Pax"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.maximumPax ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <CustomInput
                  labelText="Limit"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.limit ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <CustomInput
                  labelText="On Hold"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.onHold ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <CustomInput
                  labelText="Used"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.used ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <CustomInput
                  labelText="Available"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.limit - body.used - body.onHold ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputLabel className={classes.selectLabel}>
                  Effective From
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    value={new Date(body.effectiveFrom + "Z")}
                    onChange={e =>
                      setBody({
                        ...body,
                        effectiveFrom: e === "" ? null : e
                      })
                    }
                    dateFormat={tripDateFormat}
                    timeFormat={true}
                    disabled
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Effective From",
                      disabled: true
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputLabel className={classes.selectLabel}>
                  Effective Until
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    value={new Date(body.effectiveUntil + "Z")}
                    onChange={e =>
                      setBody({
                        ...body,
                        effectiveUntil: e === "" ? null : e
                      })
                    }
                    dateFormat={tripDateFormat}
                    timeFormat={true}
                    disabled
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Effective Until",
                      disabled: true
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  disabled
                  control={
                    <Checkbox
                      checked={body.onlyForRoundTrip}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                      disabled
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Only For Round Trip"
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  disabled
                  control={
                    <Checkbox
                      checked={body.hasSectorRestriction}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                      disabled
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Has Sector Restriction"
                />
              </GridItem>
              {body.hasSectorRestriction && (
                <GridItem xs={12} md={12}>
                  <CustomInput
                    labelText="ALLOWED ROUTES"
                    disabled
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: body.allowedSector ? body.allowedSector.name : "",
                      disabled: true
                    }}
                  />
                </GridItem>
              )}
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

ViewAgentBookingPromoCodes.propTypes = {
  history: PropTypes.object
};
